import { missingImage } from "@assets/illustrations";
import { FC } from "react";
import { Link } from "react-router-dom";
import "./NotFoundPage.css";
import SearchBar from "./components/SearchBar";

const NotFoundPage: FC = () => {
  return (
    <div className="notfound-design-system-container">
      <div className="notfound-header">
        <h1 className="notfound-title">Page not found</h1>
        <div className="notfound-search-container">
          <SearchBar indigoSize="lg" />
        </div>
      </div>

      <div className="notfound-content-card">
        <div className="notfound-illustration">
          <img src={missingImage} alt="Page not found illustration" />
        </div>
        <h2 className="notfound-heading">Page not found</h2>
        <p className="notfound-description">
          Go back to{" "}
          <Link to="/appointments" className="notfound-link">
            appointments
          </Link>
        </p>
      </div>
    </div>
  );
};

export default NotFoundPage;
